import React from 'react';
import { Helmet } from 'react-helmet';
import { useHistory } from 'react-router-dom';
import { LoadingIcon } from '.';

export default function LogoutLoading() {
  let history = useHistory();
  setTimeout(() => {
    history.push('/login');
  }, 1800);
  return (
    <>
      <Helmet>
        <title>Logout{process.env.REACT_APP_PAGETITLE_TEXT}</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <LoadingIcon loadingText="Logging out, one moment..." />
    </>
  );
}
